(function() {
    const initTrapLogic = (ageGateContainer) => {
        if (!document.getElementById('a11y-agegate-heading-style')) {
            const styleBlock = document.createElement('style');
            styleBlock.id = 'a11y-agegate-heading-style';
            // We use a highly specific selector chain combined with !important to defeat the global rule
            styleBlock.textContent = `
                #agp_row h2[tabindex="-1"]:focus,
                #agp_row h2[tabindex="-1"]:focus-visible {
                    box-shadow: none !important;
                    outline: none !important;
                }
            `;
            document.head.appendChild(styleBlock);
        }
        const ageGateRow = document.querySelector('#agp_row');
        const ageGateHeading = ageGateRow?.querySelector('h2');
        const skipLink = document.querySelector('.skip-to-content-link');

        if (ageGateHeading && !ageGateHeading.hasAttribute('tabindex')) {
            ageGateHeading.setAttribute('tabindex', '-1');
            ageGateHeading.style.outline = 'none';
        }

        const getFocusableElements = (parent) => {
            return Array.from(parent.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'));
        };

        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                e.preventDefault();
                return;
            }

            if (e.key === 'Tab') {
                const focusables = getFocusableElements(ageGateRow);
                const first = focusables[0];
                const last = focusables[focusables.length - 1];

                if (e.shiftKey && (document.activeElement === first || document.activeElement === ageGateHeading || document.activeElement === document.body)) {
                    e.preventDefault();
                    last.focus();
                } else if (!e.shiftKey && document.activeElement === last) {
                    e.preventDefault();
                    first.focus();
                }
            }
        };

        const initAgeGateAccess = () => {
            const isVisible = window.getComputedStyle(ageGateContainer).display !== 'none' && 
                              window.getComputedStyle(ageGateContainer).visibility !== 'hidden';
            
            if (isVisible) {
                if (ageGateHeading) {
                    ageGateHeading.setAttribute('tabindex', '-1');
                    ageGateHeading.style.outline = 'none';
                }

                // Give the DOM a tiny 150ms window to paint the modal window completely
                setTimeout(() => {
                    if (ageGateHeading) {
                        ageGateHeading.focus();
                    }
                }, 150);

                document.addEventListener('keydown', handleKeyDown);
                
                const yesButton = ageGateRow?.querySelector('.agp__buttonType__buttonContainer--pass input') || 
                                  ageGateRow?.querySelector('button, input[type="button"]');
                if (yesButton) {
                    yesButton.addEventListener('click', () => {
                        document.removeEventListener('keydown', handleKeyDown);
                        setTimeout(() => {
                            if (skipLink) {
                                skipLink.focus();
                            } else {
                                document.querySelector('h1')?.focus();
                            }
                        }, 150);
                    }, { once: true });
                }
            } else {
                document.removeEventListener('keydown', handleKeyDown);
            }
        };

        // Track internal display toggles on the gate container
        const subObserver = new MutationObserver(initAgeGateAccess);
        subObserver.observe(ageGateContainer, { attributes: true, attributeFilter: ['style', 'class'] });

        // Kick off focus check immediately now that it's confirmed in the DOM
        initAgeGateAccess();
    };

    // --- PARENT WATCHER: Look for the app injection ---
    const lookForAgeGate = () => {
        const targetContainer = document.querySelector('.agp__container');
        
        if (targetContainer) {
            // Found it right away!
            initTrapLogic(targetContainer);
        } else {
            // Not here yet. Set up a global observer to watch the body for its birth
            
            const birthObserver = new MutationObserver((mutations, observerInstance) => {
                const dynamicContainer = document.querySelector('.agp__container');
                if (dynamicContainer) {
                    initTrapLogic(dynamicContainer);
                    observerInstance.disconnect(); // Kill the parent watch, we found what we came for!
                }
            });

            if (document.body) {
                birthObserver.observe(document.body, { childList: true, subtree: true });
            }
        }
    };

    // Safely fire or wait for body structure
    if (document.body) {
        lookForAgeGate();
    } else {
        window.addEventListener('DOMContentLoaded', lookForAgeGate);
    }
})();